import { DataStorage } from "../../imports";

export function getCustomizeCanvas(state) {
  return DataStorage.find(state.customize.canvas);
}

export function setCustomizeCanvas(canvas) {
  return (dispatch) => {
    const pointer = DataStorage.create(canvas);
    dispatch({ type: "customize/storeCanvas", payload: pointer });
  };
}
